import styled, {
  createGlobalStyle,
  css,
  keyframes,
  ThemeProvider,
} from 'styled-components'
import { themeGet } from '@styled-system/theme-get'
import tinycolor from 'tinycolor2'
import { classicTheme, lightTheme, coolTheme, darkTheme } from './theme'

// const breakpoints = ['576px', '768px', '992px', '1200px', '1400px']

// export const device = {
//   // 미디어쿼리 모순된 값적용
//   // small: `@media (min-width: 992px) and (max-width: 991px)`,
//   // medium: `@media (min-width: 992px) and (max-width: 991px)`,
//   // large: `@media (min-width: 992px) and (max-width: 991px)`,
//   // xlarge: `@media (min-width: 992px) and (max-width: 991px)`,
//   // xxlarge: `@media (min-width: 992px) and (max-width: 991px)`,
//   // mdToLg: `@media (min-width: 992px) and (max-width: 991px)`,
//   // lgToXl: `@media (min-width: 992px) and (max-width: 991px)`,
//   small: `@media screen and (min-width: ${breakpoints[0]})`,
//   medium: `@media screen and (min-width: ${breakpoints[1]})`,
//   large: `@media screen and (min-width: ${breakpoints[2]})`,
//   xlarge: `@media screen and (min-width: ${breakpoints[3]})`,
//   xxlarge: `@media screen and (min-width: ${breakpoints[4]})`,
//   mdToLg: `@media (min-width: 768px) and (max-width: 991px)`,
//   lgToXl: `@media (min-width: 992px) and (max-width: 1199px)`,
// }
const breakpoints = [
  '320px',
  '480px',
  '576px',
  '768px',
  '992px',
  '1200px',
  '1400px',
]
export const device = {
  // Mobile First 접근법 (min-width)
  mobile: `@media screen and (min-width: ${breakpoints[0]})`, // 320px+
  mobileLarge: `@media screen and (min-width: ${breakpoints[1]})`, // 480px+
  small: `@media screen and (min-width: ${breakpoints[2]})`, // 576px+
  medium: `@media screen and (min-width: ${breakpoints[3]})`, // 768px+
  large: `@media screen and (min-width: ${breakpoints[4]})`, // 992px+
  xlarge: `@media screen and (min-width: ${breakpoints[5]})`, // 1200px+
  xxlarge: `@media screen and (min-width: ${breakpoints[6]})`, // 1400px+

  // Desktop First 접근법 (max-width) - 더 직관적
  maxMobile: `@media screen and (max-width: 479px)`, // ~479px
  maxMobileLarge: `@media screen and (max-width: 575px)`, // ~575px
  maxSmall: `@media screen and (max-width: 767px)`, // ~767px
  maxMedium: `@media screen and (max-width: 991px)`, // ~991px
  maxLarge: `@media screen and (max-width: 1199px)`, // ~1199px
  maxXlarge: `@media screen and (max-width: 1399px)`, // ~1399px

  // 범위 지정 (특정 화면 크기에서만 적용)
  onlyMobile: `@media screen and (max-width: 479px)`, // 모바일만
  onlyTablet: `@media screen and (min-width: 480px) and (max-width: 991px)`, // 태블릿만
  onlyDesktop: `@media screen and (min-width: 992px)`, // 데스크톱만

  // 기존 스타일 유지 (하위 호환성)
  mdToLg: `@media screen and (min-width: 768px) and (max-width: 991px)`,
  lgToXl: `@media screen and (min-width: 992px) and (max-width: 1199px)`,

  // 추가 유용한 범위들
  tabletPortrait: `@media screen and (min-width: 768px) and (max-width: 1024px) and (orientation: portrait)`,
  tabletLandscape: `@media screen and (min-width: 768px) and (max-width: 1024px) and (orientation: landscape)`,

  // 고해상도 디스플레이
  retina: `@media screen and (-webkit-min-device-pixel-ratio: 2), screen and (min-resolution: 192dpi)`,
}
const themes = {
  classic: classicTheme,
  light: lightTheme,
  cool: coolTheme,
  dark: darkTheme,
}

export {
  createGlobalStyle,
  css,
  keyframes,
  ThemeProvider,
  themeGet,
  classicTheme,
  darkTheme,
  tinycolor,
  themes,
}
export * from 'styled-system'
export default styled
